import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StpRegistrationStorageService } from '../../services/stp-registration-storage.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss']
})
export class SetupComponent implements OnInit {

  setupForm: FormGroup;

  // re-apply waiting period: one value for STP/SAC and course/center re-apply; every save is a new row
  cooldownForm: FormGroup;
  currentCooldownDays: number | null = null;
  cooldownHistory: any[] = [];
  isCooldownSaving = false;

  constructor(
    private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private notification: NzNotificationService
  ) {}

  ngOnInit() {
    this.setupForm = this.fb.group({
      id: [''],
      isPaymentApplicable: [false],
      paymentAmount: [''],
      deleteAfterDays: [''],
    });

    this.cooldownForm = this.fb.group({
      days: [null, [Validators.required, Validators.min(0), Validators.max(3650), Validators.pattern('^[0-9]+$')]],
      startDate: [null],
      remarks: [''],
    });

    this.getSetupInfo();
    this.getReapplyCooldownInfo();
  }

  getReapplyCooldownInfo() {
    this.stpRegistrationStorageService.getReapplyCooldownInfo().subscribe((res) => {
      if (res?.success) {
        this.currentCooldownDays = res?.data?.currentDays ?? null;
        this.cooldownHistory = res?.data?.history || [];
      }
    });
  }

  saveReapplyCooldownInfo() {
    const value = this.cooldownForm.value;
    const start: Date | null = value.startDate;
    const startDate = start
      ? `${start.getFullYear()}-${('0' + (start.getMonth() + 1)).slice(-2)}-${('0' + start.getDate()).slice(-2)}`
      : null;
    this.isCooldownSaving = true;
    this.stpRegistrationStorageService
      .saveReapplyCooldownInfo({ days: Number(value.days), startDate, remarks: value.remarks })
      .subscribe({
        next: (res) => {
          this.isCooldownSaving = false;
          if (res?.success) {
            this.notification.success('Success', res?.message);
            this.cooldownForm.reset({ days: null, startDate: null, remarks: '' });
            this.getReapplyCooldownInfo();
          } else {
            this.notification.warning('Warning', res?.message);
          }
        },
        error: (error) => {
          this.isCooldownSaving = false;
          this.notification.error('Failed', error?.error?.message || error.message);
        },
      });
  }

  getSetupInfo() {
    this.stpRegistrationStorageService.getSetupInfo()
      .subscribe((res) => {
        if(res?.success){
          this.setupForm.patchValue({
            id: res?.data?.id,
            isPaymentApplicable: res?.data?.isPaymentApplicable,
            paymentAmount: res?.data?.paymentAmount,
            deleteAfterDays: res?.data?.deleteAfterDays,
          });
        }
      });
  }

  onPaymentChange(){
    if(this.setupForm.get('isPaymentApplicable')?.value === true){
      this.setupForm.get('paymentAmount')?.setValue(null);
      this.setupForm.get('paymentAmount')?.setValidators([Validators.required, Validators.pattern('^[0-9.]+$')]);
      this.setupForm.get('paymentAmount')?.updateValueAndValidity();
    }else{
      this.setupForm.get('paymentAmount')?.setValue(null);
      this.setupForm.get('paymentAmount')?.clearValidators();
      this.setupForm.get('paymentAmount')?.updateValueAndValidity();
    }
  }

  saveSetupInfo(){
    this.stpRegistrationStorageService.saveSetupInfo(this.setupForm.value).subscribe({
      next: (res) => {
        if(res?.success){
          this.notification.success('Success', res?.message);
          this.getSetupInfo();
        }else{
          this.notification.warning('Warning', res?.message);
        }
      },
      error: (error) => this.notification.error('Failed', error.message),
    });
  }
}
